const footer = {
  quickLinks: {
    color: `#767676`,
  },
  legalLinks: {
    color: `#767676`, // `#838383` does not pass accessibility for color contrast ratio.
  },
  legalLinksActive: {
    color: `#3c8a2e`,
  },
}

const heroImage = {
  title: {
    dark: {
      color: `#024731`,
    },
    default: {
      color: `#bed600`,
    },
    light: {
      color: `#ffffff`,
    },
  },
  subtitle: {
    dark: {
      color: `#024731`,
    },
    default: {
      color: `#ffffff`,
    },
    light: {
      color: `#ffffff`,
    },
  },
  text: {
    color: `#fff`,
  },
}

const homeHero = {
  title: {
    color: `#bed600`,
  },
  text: {
    color: `#fff`,
  },
}

const myWM = {
  title: {
    color: `#57584f`,
  },
  buttonRow: {
    color: `#67696d`,
  },
}

const payMyBill = {
  background: {
    color: `#fff`,
  },
  title: {
    color: `#4f4f58`,
  },
  body: {
    color: `#4f4f58`,
  },
  error: {
    color: `#e63131`,
  },
}

const pickup = {
  body: {
    color: `#67696d`,
  },
  information: {
    color: `#838383`,
  },
}

const schedule = {
  etaStatus: {
    borderTop: `1px solid #e5e5e5`,
  },
  etaTime: {
    color: `#7a7a7a`,
  },
}

const textWithButton = {
  background: {
    color: `#024731`,
  },
  title: {
    color: `#bed600`,
  },
  button: {
    background: `#ffffff`,
    color: `#70A116`,
  },
}

const mobileLogin = {
  backButton: {
    borderBottom: `1px solid #d6d6d6`,
    color: `#1d890a`,
  },
}

export const styles = {
  footer,
  heroImage,
  homeHero,
  myWM,
  payMyBill,
  schedule,
  pickup,
  textWithButton,
  mobileLogin,
}

export const white = `#ffffff`
